import React from 'react'
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

function Terms() {
    useSEO({
        title: "Terms of Service | Empower Web",
        description: "Read our terms of service to understand the conditions for using Empower Web's services and website.",
        canonical: "https://empowerweb.in/terms",
        ogTitle: "Terms of Service | Empower Web",
        ogDescription: "Learn about the terms and conditions for using our services.",
        keywords: "terms of service, terms and conditions, legal, terms, policies"
    });
    return (
        <div>
            <Header />
            <Navbar />
            <hr />
            <section style={{padding: '40px 40px', minHeight: '70vh'}}>
                <div style={{maxWidth: '1000px', margin: '0 auto'}}>
                    <h1 style={{fontSize: '2.2rem', color:  '#0868a0',  textAlign: "left",  marginBottom: '30px'}}>Terms of Service</h1>
                    <div style={{lineHeight: '1.8', color: '#666', fontSize: '1rem'}}>
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>1. Acceptance of Terms</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
                        
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>2. Use License</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}>Permission is granted to temporarily download one copy of the materials on the Empower Web website for personal, non-commercial transitory viewing only.</p>
                        
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>3. Disclaimer</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}>The materials on Empower Web's website are provided on an 'as is' basis. Empower Web makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                        
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>4. Limitations</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }} >In no event shall Empower Web or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Empower Web's website.</p>
                        
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>5. Accuracy of Materials</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}>The materials appearing on Empower Web's website could include technical, typographical, or photographic errors. Empower Web does not warrant that any of the materials on its website are accurate, complete, or current.</p>
                        
                        <h2 style={{color: '#0868a0', marginTop: '30px',   textAlign: "left", marginBottom: '15px'}}>6. Contact</h2>
                        <p  style={{
                marginTop: "10px",
                marginBottom: "1px",
                textAlign: "left",
              }}>If you have any questions about these Terms of Service, please contact us at terms@empowerweb.in</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Terms;
